import React, { useContext, useState } from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import Api from '../../../Api';
import { InputHelper } from '../../Utils/FieldsHelper';
import MessageContext from '../../../MessageContext';

import classes from './styles.module.css';

function ProjectAdd({ token, onProjectAdd }) {
    const [isLoading, setIsLoading] = useState(false);
    const [form, setForm] = useState({
        name: '',
        description: '',
        url: '',
        legalName: '',
        inn: '',
        kpp: '',
        ogrn: '',
    });

    const { onMessage } = useContext(MessageContext);
    const intl = useIntl();

    function onChange(name, value) {
        setForm({ ...form, [name]: value });
    }

    function addProject() {
        setIsLoading(true);

        new Api({ token }).addProject(form).then((r) => {
            if (!r.errors) {
                onMessage({ type: 'success', message: intl.formatMessage({ id: 'ProjectAdd.success.created' }) });
                setForm({
                    name: '',
                    description: '',
                    url: '',
                    legalName: '',
                    inn: '',
                    kpp: '',
                    ogrn: '',
                });
                onProjectAdd();
            } else {
                const errors = Object.values(r.errors).join(' ');
                onMessage({
                    type: 'error',
                    message: intl.formatMessage({ id: 'ProjectAdd.error.create' }, { errors }),
                });
            }
            setIsLoading(false);
        });
    }

    return (
        <div>
            <InputHelper
                onChange={onChange}
                value={form.name}
                placeholder={'Alphabet Inc.'}
                fieldName={'name'}
                label={'FieldsHelper.label.projectName'}
                changeRegexp={/[^A-Za-zА-Яа-я0-9\s".]+/g}
                blurRegexp={/^[A-Za-zА-Яа-я0-9\s".]{4,10}/}
                changeMessage={'FieldsHelper.error.onlyLettersProjectName'}
                blurMessage={'FieldsHelper.error.onlyLettersProjectName'}
                isDisabled={isLoading}
            />

            <InputHelper
                onChange={onChange}
                value={form.url}
                placeholder={'https://yandex.ru/'}
                fieldName={'url'}
                label={'FieldsHelper.label.websiteUrl'}
                changeRegexp={/[^A-Za-z0-9\s/:.-]+/g}
                blurRegexp={
                    /(https?:\/\/(?:www\.|(?!www))[a-zA-Z0-9][a-zA-Z0-9-]+[a-zA-Z0-9]\.[^\s]{2,}|www\.[a-zA-Z0-9][a-zA-Z0-9-]+[a-zA-Z0-9]\.[^\s]{2,}|https?:\/\/(?:www\.|(?!www))[a-zA-Z0-9]+\.[^\s]{2,}|www\.[a-zA-Z0-9]+\.[^\s]{2,})/
                }
                changeMessage={'FieldsHelper.error.onlyUrlWebsite'}
                blurMessage={'FieldsHelper.error.checkUrlWebsite'}
                isDisabled={isLoading}
            />

            <InputHelper
                onChange={onChange}
                value={form.description}
                placeholder={''}
                fieldName={'description'}
                label={'FieldsHelper.label.description'}
                changeRegexp={/[^A-Za-zА-Яа-я0-9\s".]+/g}
                blurRegexp={/^[A-Za-zА-Яа-я0-9\s".]{4,10}/}
                changeMessage={'FieldsHelper.error.onlyLettersProjectName'}
                blurMessage={'FieldsHelper.error.onlyLettersProjectName'}
                isDisabled={isLoading}
            />

            <InputHelper
                onChange={onChange}
                value={form.legalName}
                placeholder="ООО Ромашка"
                fieldName="legalName"
                label="FieldsHelper.label.legalName"
                changeRegexp={/^$/}
                blurRegexp={/^$/}
                changeMessage="FieldsHelper.error.noValidation"
                blurMessage="FieldsHelper.error.noValidation"
                isDisabled={isLoading}
            />

            <InputHelper
                onChange={onChange}
                value={form.inn}
                placeholder="7707083893"
                fieldName="inn"
                label="FieldsHelper.label.inn"
                changeRegexp={/^$/}
                blurRegexp={/^$/}
                changeMessage="FieldsHelper.error.noValidation"
                blurMessage="FieldsHelper.error.noValidation"
                isDisabled={isLoading}
            />

            <InputHelper
                onChange={onChange}
                value={form.kpp}
                placeholder="770701001"
                fieldName="kpp"
                label="FieldsHelper.label.kpp"
                changeRegexp={/^$/}
                blurRegexp={/^$/}
                changeMessage="FieldsHelper.error.noValidation"
                blurMessage="FieldsHelper.error.noValidation"
                isDisabled={isLoading}
            />

            <InputHelper
                onChange={onChange}
                value={form.ogrn}
                placeholder="1027700132195"
                fieldName="ogrn"
                label="FieldsHelper.label.ogrn"
                changeRegexp={/^$/}
                blurRegexp={/^$/}
                changeMessage="FieldsHelper.error.noValidation"
                blurMessage="FieldsHelper.error.noValidation"
                isDisabled={isLoading}
            />

            <button className={classes.Btn} onClick={addProject} disabled={isLoading}>
                {isLoading ? (
                    <FormattedMessage id="ProjectAdd.btn.saving" defaultMessage="Сохраняем..." />
                ) : (
                    <FormattedMessage id="ProjectAdd.btn.add" defaultMessage="Добавить проект" />
                )}
            </button>
        </div>
    );
}

export default ProjectAdd;



// WEBPACK FOOTER //
// ./src/Components/ComponentsOfAdministrator/ProjectAdd/index.js